import { render, staticRenderFns } from "./OrganismIdcCustomerManagement.vue?vue&type=template&id=4f7099d7&scoped=true&"
import script from "./OrganismIdcCustomerManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismIdcCustomerManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismIdcCustomerManagement.vue?vue&type=style&index=0&id=4f7099d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7099d7",
  null
  
)

export default component.exports